import { NgModule } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { CoreModule } from 'src/app/core/core.module';
import { HistoryModule } from '../history/history.module';
import * as General from './general.components';
import { GeneralRecipeItemComponent } from './recipe/general-recipe-item.component';
import { GeneralRecipeComponent } from './recipe/general-recipe.component';

const COMPONENTS = [
  General.ConsultComponent,
  General.ConsultFiliationDataComponent,
  General.ConsultVitalSignComponent,
  General.ConsultSubjectComponent,
  General.ConsultDiseaseComponent,
  General.ConsultOrganComponent,
  General.ConsultExaminationComponent,
  General.ConsultAnalysisComponent,
  General.ConsultAdditionalComponent,
  General.ConsultTreatmentPlanComponent,
  General.ConsultDiagnosticComponent,
  General.ConsultCatalogItemComponent,
  General.ConsultCatalogItemReadonlyComponent,
  General.ConsultDiagnosticItemComponent,
  General.ConsultWrapperComponent,
  General.VitalSignComponent,
  GeneralRecipeComponent,
  GeneralRecipeItemComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CoreModule, HistoryModule, TabViewModule],
  entryComponents: [],
  exports: [...COMPONENTS],
})
export class GeneralModule {}
